export enum SERVICE_TYPE_GROUP_ENUM {
  Booking = 1,
  Report = 2,
  CRM = 3,
}
